<custom-navbar barTitle="공지사항" [showSetting]="false"></custom-navbar>
<div class="notice-wrap">
  <div class="notice-list">
    <div (click)="openNotice(data)" *ngFor="let data of noticeList let index=index">
      <div class="notice-title">
        <div class="notice-title-content">
          {{data.title}}
          <div class="notice-new-icon" *ngIf="data.isNew">N</div>
          <div class="notice-title-date">{{data.date | date: 'yyyy-MM-dd'}}</div>
        </div>
        <mat-icon class="notice-arrow-icon nomal" *ngIf="!data.status">keyboard_arrow_down</mat-icon>
        <mat-icon class="notice-arrow-icon red" *ngIf="data.status">keyboard_arrow_up</mat-icon>
      </div>
      <div class="notice-content" [ngClass]="data.status ? 'show' : ''" [innerHTML]="data.content"></div>
    </div>
  </div>
  <div class="notice-more" (click)="getNoticeList()" *ngIf="hasMoreNotice">
    더보기<mat-icon class="icon">expand_more</mat-icon>
  </div>
</div>
